// webpacker.ymlのresolved_pathsに指定したプレフィックスは省略可能

// Vue.js
import Vue from "vue/dist/vue.esm";

// /components/companies
import CompanyCards from "components/companies/CompanyCards.vue";
import CompanySummary from "components/companies/CompanySummary.vue";
import CompanyFieldsOfSpecialty from "components/companies/CompanyFieldsOfSpecialty.vue";
import SearchAutoComplete from "components/companies/SearchAutoComplete.vue";
import VTabs from "components/companies/VTabs.vue";
import CompanyDetailHead from "components/companies/CompanyDetailHead.vue";
import ServiceTags from "components/companies/ServiceTags.vue";
import CompanyPhoto from "components/companies/CompanyPhoto.vue";
import CompanyIndexCard from "components/companies/CompanyIndexCard.vue";

// /components/case_studies
import CaseStudyCard from "components/case_studies/CaseStudyCard.vue";
import CaseStudySimpleCard from "components/case_studies/CaseStudySimpleCard.vue";

// import(/* webpackChunkName: "CompanyCards" */'components/companies/CompanyCards.vue');

// /components
import CustomMdbSelecter from "components/CustomMdbSelecter.vue";
import VChart from "components/VChart.vue";

export default new Vue({
  el: "#vue-app",
  components: {
    CompanyCards,
    CompanySummary,
    CompanyFieldsOfSpecialty,
    SearchAutoComplete,
    VTabs,
    CustomMdbSelecter,
    VChart,
    CompanyDetailHead,
    CaseStudyCard,
    CaseStudySimpleCard,
    ServiceTags,
    CompanyPhoto,
    CompanyIndexCard
  },
  mounted() {
    $(".case-study-card").matchHeight();
    $(".card-title").matchHeight();
  }
});
